module.exports = __webpack_public_path__ + "static/bolsa-horas-375b0cc04bbca8cec1e001bea2458dfa.svg";